import { PhoneProvider } from '../phoneContext';

export default PhoneProvider;
